const UTILS = (() => {
  var methods = {};
  
  methods.getCart = async () => {
    return await fetch('/cart.js').then(res => res.json());
  };

  methods.refreshCart = () => {
    if (document.body.classList.contains('template-cart')){
      console.log('reload cart page');
      window.location.reload();
    }else {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    }
  };

  methods.addItemToCart = async (p_options) => {
    var itemsToAdd = {
      quantity: p_options.quantity,
      id: p_options.variant_id,
      selling_plan: p_options.selling_plan
    };

    if (p_options.properties !== undefined) {
      itemsToAdd['properties'] = p_options.properties;
    }

    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: [itemsToAdd] })
    });
  };

  methods.removeItemFromCart = async (itemToRemove) => {
    let req = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemToRemove)
    })
    return req;
  }

  methods.formatMoney = (value) => {
    return theme.Currency.formatMoney(value);
  }

  return methods;
})();

document.addEventListener('click', function (event) {
	// If the clicked element doesn't have the right selector, bail
    if (!event.target.matches('.faq-article .title')) return;

	// Don't follow the link
	event.preventDefault();
    event.target.closest('.faq-article').classList.toggle('open');
}, false);
document.addEventListener('DOMContentLoaded', function () {
  // hand hugs added for truncated produc description
  let read_more = document.getElementById('read-more');
  let read_less = document.getElementById('read-less');
  let truncated_description = document.getElementById('truncated-product-description');
  let full_description = document.getElementById('product-description');
  if (typeof(read_more) != 'undefined' && read_more != null)
  {
    read_more.addEventListener('click', showHideDescription)
    read_less.addEventListener('click', showHideDescription)
  }
  function showHideDescription(){
    let ID = this.id
    if(ID === "read-more"){
      truncated_description.style.display = "none";
      full_description.style.display = "block";
    }else {
      truncated_description.style.display = "block";
      full_description.style.display = "none";    
    }
  }
}, false);

document.addEventListener('alpine:init', () => {
  Alpine.data('CartShipUpsells', () => ({
      threshold: {
        freegift: 0,
        freeship: 0
      },
      data: {
        freegift_handle: 'nossa-trucker',
        subscription_weight: 0,
        remaining: {
          freeship: 0,
          freegift: 0
        },
        progress: {
          freeship: 0,
          freegift: 0
        },
        flags: {
          freeship: false,
          freegift: false,
          freegiftAdded: false,
          cart_subscriptions: false
        },
        cart: null
      },
      init() {
        let am = this;
        (async() => {
          let cart = await UTILS.getCart();
          am.data.cart = cart;
          am.checkEligibility();
        })();

        document.addEventListener('cart-updated', async (e) => {
          let cart = await UTILS.getCart();
          am.data.cart = cart;
          am.checkEligibility();
        });
      },
      setThresholdSettings(p_options) {
        let am = this;
        am.threshold[p_options.key] = p_options.value;
        am.data.remaining[p_options.key] = p_options.value;
      },
      setFreegiftHandle(handle) {
        let am = this;
        am.data.freegift_handle = handle;
      },
      getCartTotal() {
        let am = this;
        return am.data.cart ? am.data.cart.total_price : 0;
      },
      getCartWeight() {
        // note for jessie - we will need to create a running total of subscription weights instead of getting carts total weight
        let am = this;
        var subscription_weight = 0;
        let subscription_item = am.data.cart.items.find((item) => {
          return !!item.selling_plan_allocation ? item : null;
        });
        if (subscription_item){
          var subscription_weight = subscription_weight + (subscription_item.grams * subscription_item.quantity);
        }
        console.log('weight:'+subscription_weight);
        return subscription_weight;
      },
      getGiftItemInCart() {
        let am = this;
        let gift_item = am.data.cart.items.find((item) => {
          return item.handle == am.data.freegift_handle ? item : null;
        });
        return gift_item;
      },
      formatMoney(value) {
        return theme.Currency.formatMoney(value);
      },
      checkEligibility() {
        let am = this, freeship = false, freegift = false;

        let remaining_freeship = am.threshold.freeship - am.getCartTotal();
        freeship = remaining_freeship <= 0;
        am.data.remaining.freeship = remaining_freeship;
        am.data.flags.freeship = freeship;
        am.data.progress.freeship = (((am.threshold.freeship - remaining_freeship) / am.threshold.freeship) * 100).toFixed(2) + '%';

        let remaining_freegift = am.threshold.freegift - am.getCartTotal();
        freegift = remaining_freegift <= 0;
        am.data.remaining.freegift = remaining_freegift;
        am.data.flags.freegift = freegift;        
        am.data.flags.freegiftAdded = am.getGiftItemInCart();
        am.data.progress.freegift = (((am.threshold.freegift - remaining_freegift) / am.threshold.freegift) * 100).toFixed(2) + '%';

        let remaining_subscription = am.threshold.subscription_ship - am.getCartWeight();
        console.log('remaining:'+remaining_subscription);
        subscriptionship = remaining_subscription <= 0;
        am.data.remaining.subscriptionship = remaining_subscription;
        am.data.flags.subscription_ship = subscriptionship;        
        am.data.progress.subscriptionship = 'add one more bag of coffee for free subscription shipping.';

        
        // other conditions
        let cart_subscriptions = !!am.data.cart.items.find(item => !!item.selling_plan_allocation);
        am.data.flags.cart_subscriptions = cart_subscriptions;

        setTimeout(() => {
          let $bar = document.querySelectorAll('.cart-upsell .bar');
          if ($bar) {
            for (i = 0; i < $bar.length; ++i) {
              $bar[i].style.setProperty('--fg_progress', am.data.progress.freegift);
            }
          }  
        }, 0);

        // if (!freegift) {
        //   am.removeGiftItemFromCart();
        // }
      },
      addGiftItemToCart(e) {
        (async () => {
          let variant_id = e.target.dataset.variant_id;
          let variantToAdd = {
            variant_id: variant_id,
            quantity: 1,
            properties: {
              '__gift-upsell': 'true'
            }
          };

          let res = await UTILS.addItemToCart(variantToAdd);
          if (res.ok) {
            UTILS.refreshCart();
          }
        })();
      },
      removeGiftItemFromCart() {
        let am = this;
        let gift_item = am.getGiftItemInCart();
        if (!gift_item) return;

        (async () => {
          let remove = {
            id: gift_item.key,
            quantity: 0
          };
          let res = await UTILS.removeItemFromCart(remove);
          if (res.ok) {
            UTILS.refreshCart();
          }
        })();
      },
      toggleGiftItemCart(e) {
        e.preventDefault();
        let am = this;
        let $target = e.target;
        let isAdd = $target.checked;

        if (isAdd) {
          // add free gift
          am.addGiftItemToCart(e);
        }
        else {
          // remove free gift
          am.removeGiftItemFromCart();
        }
      }
  }));
})  